const BASE_URL = 'https://api.dev.auxo.dk';

export async function fetchCMSCollection(collectionName, params = {}) {
  try {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        query.append(key, value);
      }
    });
    
    const queryString = query.toString();
    const url = `${BASE_URL}/public/v2/content/${collectionName}${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch collection ${collectionName}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('CMS Fetch Error:', error);
    return { items: [], total: 0 };
  }
}

export async function fetchCMSPageBySlug(pageSlug) {
  try {
    // We can fetch the pages collection and find the one with page_slug matching
    const data = await fetchCMSCollection('pages');
    if (data && data.items) {
      const page = data.items.find(item => item.page_slug === pageSlug);
      if (page) return page;
    }
    return null;
  } catch (error) {
    console.error(`Error fetching page by slug ${pageSlug}:`, error);
    return null;
  }
}

export async function fetchCMSGalleryBySlug(gallerySlug) {
  try {
    const data = await fetchCMSCollection('gallery');
    if (data && data.items) {
      const gallery = data.items.find(item => item.gallery_slug === gallerySlug);
      if (gallery) return gallery;
    }
    return null;
  } catch (error) {
    console.error(`Error fetching gallery by slug ${gallerySlug}:`, error);
    return null;
  }
}
